import { fetcher } from '../Fetchers/fetcher';

export const getShow = ({ slug }) => fetcher(`v1/shows/slug/${slug}`);
export const getSettings = ({ showId, error }) => fetcher(`v1/shows/${showId}/settings`, {}, error);
export const sendSubscriber = ({ showId, body, update }) => fetcher(`v1/shows/${showId}/subscribers`, { method: 'POST', body }, {}, update);